// features/cartitemsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiurl } from "../Constants";

// Fetch wishlist items
export const fetchWishlists = createAsyncThunk(
  "wishlists/fetchWishlists",
  async (user_id, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiurl + "wishlist", {
        user_id: user_id,
      });
      return response.data.product;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const wishlistItemsslice = createSlice({
  name: "fetchlists",
  initialState: {
    items: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWishlists.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchWishlists.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
      })
      .addCase(fetchWishlists.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default wishlistItemsslice.reducer;
